module.exports = __webpack_public_path__ + "img/exchange-arrows.4d6ba69e.svg";